/* tslint:disable */
/* eslint-disable */
/**
 * ReD Admin API Spec
 * ReD中途企業向けサイト用API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@redesigner.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetCompanyRoles200ResponseRolesInner } from './GetCompanyRoles200ResponseRolesInner';
import {
    GetCompanyRoles200ResponseRolesInnerFromJSON,
    GetCompanyRoles200ResponseRolesInnerFromJSONTyped,
    GetCompanyRoles200ResponseRolesInnerToJSON,
} from './GetCompanyRoles200ResponseRolesInner';

/**
 * 
 * @export
 * @interface GetCompanyRoles200Response
 */
export interface GetCompanyRoles200Response {
    /**
     * ステータス
     * @type {number}
     * @memberof GetCompanyRoles200Response
     */
    status: number;
    /**
     * メッセージ
     * @type {string}
     * @memberof GetCompanyRoles200Response
     */
    message: string;
    /**
     * 返却件数
     * @type {number}
     * @memberof GetCompanyRoles200Response
     */
    count: number;
    /**
     * 権限
     * @type {Array<GetCompanyRoles200ResponseRolesInner>}
     * @memberof GetCompanyRoles200Response
     */
    roles?: Array<GetCompanyRoles200ResponseRolesInner>;
}

/**
 * Check if a given object implements the GetCompanyRoles200Response interface.
 */
export function instanceOfGetCompanyRoles200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "message" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function GetCompanyRoles200ResponseFromJSON(json: any): GetCompanyRoles200Response {
    return GetCompanyRoles200ResponseFromJSONTyped(json, false);
}

export function GetCompanyRoles200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCompanyRoles200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'count': json['count'],
        'roles': !exists(json, 'roles') ? undefined : ((json['roles'] as Array<any>).map(GetCompanyRoles200ResponseRolesInnerFromJSON)),
    };
}

export function GetCompanyRoles200ResponseToJSON(value?: GetCompanyRoles200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'count': value.count,
        'roles': value.roles === undefined ? undefined : ((value.roles as Array<any>).map(GetCompanyRoles200ResponseRolesInnerToJSON)),
    };
}

